<h2 mat-dialog-title>Review is too short</h2>
<mat-dialog-content class="mat-typography">
    <p [innerHtml]="content" style="white-space: pre-line;"></p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false">Submit it anyway</button>
  <button mat-raised-button [mat-dialog-close]="true" cdkFocusInitial color="primary">Close</button>
</mat-dialog-actions>